<template>
<div class="gi-title" :class="{'is-light': theme==='light'}">
  <h1 v-if="data.h1">{{data.h1}}</h1>
  <h2 v-if="data.h2">{{data.h2}}</h2>
</div>
</template>

<script>
export default {
  props: ['data', 'theme']
}
</script>

<style lang="sass">

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.gi-title
  text-align: center
  color: #000
  margin-bottom: 40px
  h1
    font-size: 36px
  h2
    font-size: 16px
    color: #333
  +mobile
    margin-bottom: 20px
    h1
      font-size: 22px
    h2
      font-size: 16px
  &.is-light
    color: #fff
    h2
      color: #eee
</style>



// WEBPACK FOOTER //
// src/components/title/title.vue